import React from "react";
import UnderConstruction from "../../components/underConstruction";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {}

  render() {
    if (this.state.hasError) {
      return <UnderConstruction error={true} />;
    }

    return this.props.children;
  }
}
export default ErrorBoundary;